export default __webpack_public_path__ + "static/media/appleappstore.e964156b.png";